import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { sizes } from 'src/styles/Media.styled';
import {
    QuestionTitle,
    RadioButtonView,
    QuestionContainer,
} from './QuestionCard.styled';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import { useTranslation } from 'react-i18next';

const QuestionCard = ({
    question,
    isChecked,
    onChange,
    children,
    isLastCard,
}) => {
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.smalDevice;
    const { t } = useTranslation();
    return (
        <Box
            my={1}
            bgcolor={'#ffffff'}
            boxShadow={'0px 0px 6px #00000029'}
            borderRadius={5}
            padding={isMobileView ? '16px 28px 16px 24px' : '16px 22px'}
            width={'99.66%'}
            border={isChecked !== '' ? '1px solid #12C8F7' : ''}
            marginLeft={'1px'}
            marginRight={'1px'}
            marginBottom={isLastCard && '30px'}
        >
            <QuestionContainer>
                <QuestionTitle>{question}</QuestionTitle>
                <RadioButtonView>
                    <Grid lg={6} sm={6} xs={6}>
                        <RadioButton
                            isChecked={isChecked}
                            id={'report-payment-yes'}
                            label={t(
                                'reportUsage.record.reportPayment.ReportPayment.yes'
                            )}
                            handleChange={() => onChange('Yes')}
                            fontFamilyStyle="AvenirNextWorld Regular"
                            fontSize="15px"
                            // iPadPaddingRight="35%"
                        />
                    </Grid>
                    <Grid lg={6} sm={6} xs={6}>
                        <RadioButton
                            isChecked={isChecked === false ? true : false}
                            id={'report-payment-no'}
                            label={t('equity.surgery.notifications.no')}
                            handleChange={() => onChange('No')}
                            fontFamilyStyle="AvenirNextWorld Regular"
                            fontSize="15px"
                        />
                    </Grid>
                </RadioButtonView>
            </QuestionContainer>
            {children}
        </Box>
    );
};

export default QuestionCard;
